import { localizeUrl, readUrlLocale } from 'i18n/urlLocale';

// On a locale-prefixed page (/ja/...), a same-site page link gets the prefix
// once it is hovered, focused, touched or dragged, and at the latest just
// before it is followed; a form gets it on submit. The next page stays in that locale
// (docs/i18n.md, "Locale-prefixed URLs"). Most links are built from the
// unprefixed site URL; this covers them all without each one knowing. The
// listeners capture, so they run before client navigation reads the href.
// Returns a function that removes them.
export function bindLocaleLinks(rootDocument) {
	const settings = readUrlLocale(rootDocument);
	if(!settings.locale) {
		return () => {};
	}
	const view = rootDocument.defaultView;
	const options = () => ({ ...settings, origin: view.location.origin });

	const onLink = (event) => {
		const link = event.target.closest && event.target.closest('a[href]');
		if(!link || link.hasAttribute('download')) {
			return;
		}
		const href = link.getAttribute('href');
		const localized = localizeUrl(href, options());
		if(localized !== href) {
			link.setAttribute('href', localized);
		}
	};

	const onSubmit = (event) => {
		const form = event.target;
		if(!form || !form.hasAttribute || !form.hasAttribute('action')) {
			return;
		}
		const action = form.getAttribute('action');
		const localized = localizeUrl(action, options());
		if(localized !== action) {
			form.setAttribute('action', localized);
		}
	};

	// Hover and focus put the prefixed URL in the status bar, dragstart covers
	// dragging a link to the tab bar, and touchstart covers iOS long press,
	// which copies the link without a contextmenu event.
	const capture = { capture: true };
	const linkEvents = {
		click: capture,
		auxclick: capture,
		contextmenu: capture,
		mouseover: capture,
		focusin: capture,
		dragstart: capture,
		touchstart: { capture: true, passive: true },
	};
	Object.entries(linkEvents).forEach(([type, options]) => rootDocument.addEventListener(type, onLink, options));
	rootDocument.addEventListener('submit', onSubmit, true);
	return () => {
		Object.entries(linkEvents).forEach(([type, options]) => rootDocument.removeEventListener(type, onLink, options));
		rootDocument.removeEventListener('submit', onSubmit, true);
	};
}
